// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__Uiz6w","project-cards":"Projects_project-cards__dp2OA","project-card":"Projects_project-card__wKHci"};